<template>
  <!-- Ticket-Detail neu aufbauen, wenn nur die id wechselt (Link vom Reklamations- zum
       Originalticket): die Seite lädt ihre Daten in onMounted. Alle anderen Routen
       behalten das Standardverhalten. -->
  <router-view v-slot="{ Component, route }">
    <component :is="Component" :key="route.name === 'ticket-detail' ? route.fullPath : undefined" />
  </router-view>
</template>

<script setup lang="ts">
</script>
